<script lang="ts" setup>
import { MenuItem } from '@headlessui/vue'

interface Props {
  unread: boolean
  as?: string
}

withDefaults(defineProps<Props>(), {
  as: 'MenuItem',
})
</script>

<template>
  <component :is="as === 'MenuItem' ? MenuItem : as" class="block">
    <div
      class="notify relative block w-full cursor-pointer whitespace-normal px-2 py-1 text-xs text-primary after:absolute after:inset-0 after:z-10"
      role="button"
      :class="{
        'text-white after:bg-primary after:opacity-80 hover:after:opacity-90':
          unread,
        'after:bg-primary after:opacity-10 hover:after:opacity-20':
          as === 'MenuItem',
        'bg-primary py-2 text-white hover:bg-primaryDark hover:text-white':
          as !== 'MenuItem',
      }"
    >
      <div class="relative z-20">
        <slot />
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
.notify {
  width: min(300px, calc(100vw - 70px));
}
</style>
